import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit,
         SimpleChanges } from '@angular/core';

import { BulkAmountConfig, PriceConfig } from 'app/product-designer-config';
import { ConfigService } from 'core/config/config.service';
import { Price } from './price';
import { PriceFormatPipe } from './price-format.pipe';

@Component({
    selector: 'price-display',
    templateUrl: './price-display.component.html',
    styleUrls: ['./price-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PriceDisplayComponent implements OnInit, OnChanges
{
  @Input('price') public price: BulkAmountConfig|Price|PriceConfig;
  @Input('quantity') public quantity: number = 1;
  @Input() public display: string = 'default';
  @Input() public showAsAddition: boolean = false;
  @Input() public showPriceLabel: boolean = false;
  @Input() public name: string|undefined = undefined;
  public pricePerUnit: string = '';

  private priceFormatPipe: PriceFormatPipe;

  constructor(@Inject(ConfigService) configService: ConfigService)
  {
    this.priceFormatPipe = new PriceFormatPipe(configService);
  }

  public ngOnInit(): void
  {
    this.updatePricePerUnit(this.price);
  }

  public ngOnChanges(changes: SimpleChanges): void
  {
    if ('price' in changes) {
      this.updatePricePerUnit(changes['price'].currentValue);
    }
  }

  private updatePricePerUnit(
      price: BulkAmountConfig|Price|PriceConfig): void
  {
    this.pricePerUnit = `
      <span class="regular-price">
        ${this.priceFormatPipe.transform(price.regularAmount.toString())}</span>
      <span class="reduced-price">
        ${this.priceFormatPipe.transform(price.reducedAmount.toString())}
      </span>`;
  }
}
